"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuadElementSharedObject = void 0;
const rc_js_util_1 = require("rc-js-util");
class QuadElementSharedObject {
    constructor(wrapper) {
        this.rvp = rc_js_util_1.RawVoidPointer.createOne(wrapper, QuadElementSharedObject.byteSize, true);
        this.sharedObject = this.rvp.sharedObject;
    }
    update(entityId, dataId, filterMask) {
        const dataView = this.rvp.getDataView();
        dataView.setUint32(0, entityId, QuadElementSharedObject.littleEndian);
        dataView.setUint32(Uint32Array.BYTES_PER_ELEMENT, dataId, QuadElementSharedObject.littleEndian);
        dataView.setUint32(Uint32Array.BYTES_PER_ELEMENT * 2, filterMask, QuadElementSharedObject.littleEndian);
    }
}
exports.QuadElementSharedObject = QuadElementSharedObject;
QuadElementSharedObject.elementCount = 3;
QuadElementSharedObject.byteSize = Uint32Array.BYTES_PER_ELEMENT * QuadElementSharedObject.elementCount;
QuadElementSharedObject.littleEndian = rc_js_util_1.isLittleEndian;
//# sourceMappingURL=quad-element-shared-object.js.map